<template>
    <div   v-loading="listLoading">
        <el-checkbox-group v-model="facArr" @change="change">
            <el-checkbox-button v-for="fac in facList" :label="fac.keyWord" :key="fac.name">{{fac.name}}</el-checkbox-button>
        </el-checkbox-group>
        <div id="chartLine"></div>

             
		<el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="true" >
            <el-tag    effect="plain" v-if="chooseIndex>-1" >    时间：{{ dataObj.timeList[chooseIndex] }} </el-tag>
            <el-tag    v-for="(item,index) in facArr"  :key="item"     effect="plain" v-if="chooseIndex>-1" style="margin-left: 20px;">     {{ factorName[index] }}：{{ dataObj[item][chooseIndex] }} </el-tag>
            <el-descriptions title="异常报警"  :column="2" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="stateInfo.length>0">
                <template v-for="item in stateInfo">
                    <el-descriptions-item  label="时间"> {{item.time}}  </el-descriptions-item>
                    <el-descriptions-item  label="事件"> {{item.remark}} </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="声源定位"  :column="2" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="noiseVideo.length>0">
                <template v-for="item in noiseVideo">
                    <el-descriptions-item  label="时间"> {{item.alarmDate}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
					    <el-button size="small" @click="showIdent(item)">查看视频</el-button>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="噪声录音"  :column="2" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="recording.length>0">
                <template v-for="item in recording">
                    <el-descriptions-item  label="时间"> {{item.startTime}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
                        <audio :src="item.src" controls="controls"></audio>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
        </el-dialog>

        <el-dialog title="视频详情" :visible.sync="soundVisible" top="8vh" >
			<video :src="mp4Src" controls="controls" style="width: 100%;"></video>
		</el-dialog>
    </div>
</template>

<script>
import {setDeviceEvent} from '../../../static/fun.js';
 import * as echarts from "echarts";
export default {
name: 'single-device-chart',
props: {
    dataObj: {
        type: Object,
        default: () => {
            return {}
        }
    },
    facList: {
        type: Array,
        default: () => {
            return []
        }
    },
    formHeight: {
        type: Number,
        default: () => {
            return 0
        }
    },
    dataType: {
        type: String,
        default: () => {
            return "min"
        }
    },
    facMap: {
        type: Map,
        default: () => {
            return "min"
        }
    },
    showTable: {
        type: Boolean,
        default: () => {
            return true
        }
    },
    listLoading: {
        type: Boolean,
        default: () => {
            return false
        }
    },
    collapsed: {
        type: Boolean,
    },
    linkage:{
        type:Boolean
    },
    choosemn:{
        type:String
    }
},
data () {
  return {
    facArr:[],
    factorName:[],
    chartLine:null,
    noiseVideo:[],
    recording:[],
    stateInfo:[],
    deviceDataVisible:false,
    mp4Src:"",
    soundVisible:false,
    chooseIndex:-1
  }
},
mounted () {
    var _this=this;
    window.onresize = function(){
        if(_this.chartLine!=null){
            _this.chartLine.resize();
        }
    }
},
watch: {
    'collapsed': {
        handler (val) {
            if(this.chartLine!=null){
                this.chartLine.resize();
            }
        },
        deep: true
    },
    'dataObj': {
      handler (val) {
        this.handleData();
      },
      deep: true
    },
    'formHeight': {
      handler (val) {
        if(this.formHeight!=0){
            document.getElementById("chartLine").style.height=this.formHeight+"px";
        }
      },
      deep: true
    },
},
methods: {
    showIdent(row){
        this.mp4Src=window.configuration.resourceUrlJava+"video/"+row.videoPaths;
        this.soundVisible=true;
    },
    change(a){
        this.factorName=[];
        this.facArr.forEach(element => {
            this.factorName.push(this.facMap.get(element));
        });
        this.chooseIndex=-1;
        this.clickEvent();
    },
    handleData(){
        if(this.showTable){
            return;
        }

        //刚进来的时候
        if(this.facArr.length==0){
            this.facArr=[];
            this.factorName=[];
            if(this.facList.length>0){
                this.facArr.push(this.facList[0].keyWord);
                this.factorName.push(this.facList[0].title);
            }
        }
        this.aData=this.dataObj.timeList;
        let seriesData=[];
        //对因子进行循环
        var i=0;
        this.factorName.forEach((item)=>{

            var data=this.dataObj[this.facArr[i]];
            let factorOne={};
            factorOne.type='line';
            factorOne.name=item;
            factorOne.connectNulls=false;
            factorOne.data=data;
            var dataTep=50;
            //判断有没有事件
            if(this.linkage&&i==0){//只给第一个因子加事件
                var pointdata=[];
                for (let index = 0; index < data.length; index++) {
                    var element = data[index];
                    if(element!="-"){
                        dataTep=element;
                    }else{
                        element=dataTep;
                    }
                    //1、先判断异常事件  stateInfo  红色
                    if(this.dataObj.stateInfo[index]!="-"){
                        pointdata.push({
                            name: '事件', value: '事件', xAxis: index, yAxis: element,itemStyle: { color:'#FF0033' }
                        })
                    }else if(this.dataObj.noiseAlarm[index]!="-"){
                        pointdata.push({
                            name: '定位', value: '定位', xAxis: index, yAxis: element,itemStyle: { color:'#FF9900' }
                        })
                    }else if(this.dataObj.recording[index]!="-"){
                        pointdata.push({
                            name: '录音', value: '录音', xAxis: index, yAxis: element,itemStyle: { color:'#FF9900' }
                        })
                    }
                }
                if(pointdata.length>0){
                    factorOne.markPoint={data:pointdata}
                }
            }
            factorOne.smooth=true;
            seriesData.push(factorOne);
            i++;
        });
                  
        this.drawLineChart(seriesData); 
    },
    drawLineChart:function(seriesData) {
        document.getElementById("chartLine").style.height=this.formHeight+"px";
        var tit = ['','',''];
        var legendTep = tit.concat(this.factorName);
        this.chartLine = echarts.init(document.getElementById('chartLine'));

        this.chartLine.setOption({
            title: {
                text: '分析趋势图',
                x:'center'
                // text: '数据趋势图'
            },
            tooltip: {
                trigger: 'axis'
            },
            toolbox: {
                show : true,
                feature: {
                    dataZoom: {
                        yAxisIndex:"none"
                    },
                    magicType: {show: true, type: ['line', 'bar']},
                    saveAsImage: {
                        show:true,
                        excludeComponents :['toolbox'],
                        pixelRatio: 2
                    }
                }
            },
            legend: {
                data: legendTep,
                itemWidth: 10,  // 设置宽度
                itemHeight: 10, // 设置高度
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top:60,
                containLabel: true
            },
            xAxis: {
                boundaryGap: true,
                name:'时间',
                data:this.aData
            },
            yAxis: {
                type: 'value',
                name:'数值',
                scale:true
            },
            series:seriesData
        },true);


        var _this=this;
        if(this.linkage){
            this.chartLine.off('click');
            this.chartLine.on('click', function (param) {
                var index=param.data.xAxis;//第几个数据
                if(_this.dataObj.noiseAlarm[index]!="-"){
                    _this.noiseVideo=eval("("+_this.dataObj.noiseAlarm[index]+")");
                }else{
                    _this.noiseVideo=[];
                }
                if(_this.dataObj.recording[index]!="-"){
                    _this.recording=eval("("+_this.dataObj.recording[index]+")");
                }else{
                    _this.recording=[];
                }
                if(_this.dataObj.stateInfo[index]!="-"){
                    _this.stateInfo=eval("("+_this.dataObj.stateInfo[index]+")");
                }else{
                    _this.stateInfo=[];
                }

                //处理异常报警
                if(_this.stateInfo.length>0){
                    for (let index = 0; index < _this.stateInfo.length; index++) {
                        const data = _this.stateInfo[index];
                        data.remark=setDeviceEvent(data);
                    }
                }
                if(_this.recording.length>0){
                    _this.recording.forEach(element => {
                        element.src=window.configuration.resourceUrlJava+"recording/"+_this.choosemn+"/"+element.fileFolderName+"/"+element.filename;
                    });
                }
                _this.chooseIndex=index;

                _this.deviceDataVisible=true;
            });
        }
    },
    clickEvent(){
        this.$emit('select-type',this.facArr.toString());
    },
}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// SingleDeviceChart.vue?1e8f5ad0